module.exports = __webpack_public_path__ + "img/close.cc377f5c.svg";